import {usePagination, UsePaginationProps} from 'react-instantsearch';
import clsx from 'clsx';

export const Pagination = (props: UsePaginationProps) => {
  const {currentRefinement, nbPages, refine} = usePagination(props);
  const firstIndexPage = 0;
  const lastIndexPage = nbPages - 1;

  const getPageRange = () => {
    const maxPages = 5;
    const pageRange = [];

    const start = Math.max(currentRefinement - 2, firstIndexPage);
    const end = Math.min(start + maxPages, lastIndexPage);

    for (let i = start; i <= end; i++) {
      pageRange.push(i);
    }

    if (end < lastIndexPage) {
      pageRange.push(null);
      pageRange.push(nbPages);
    }

    return pageRange;
  };

  return (
    <nav className="flex items-center justify-between border-t border-gray-200 px-4 sm:px-0">
      <div className="-mt-px flex w-0 flex-1">
        <button
          disabled={currentRefinement === firstIndexPage}
          onClick={(event) => {
            event.preventDefault();
            refine(currentRefinement - 1);
          }}
          className="inline-flex items-center border-t-2 border-transparent pr-1 pt-4 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700"
        >
          <svg
            className="mr-3 h-5 w-5 text-gray-400"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"
            />
          </svg>
          Previous
        </button>
      </div>
      <div className="hidden md:-mt-px md:flex">
        {getPageRange().map((page) => {
          if (page === null) {
            return (
              <span
                key={page}
                className="inline-flex items-center px-4 pt-4 text-sm font-medium text-gray-500"
              >
                ...
              </span>
            );
          }
          return (
            <button
              key={page}
              className={clsx(
                currentRefinement === page
                  ? 'border-indigo-500 text-indigo-600'
                  : 'text-gray-500 hover:border-gray-300 hover:text-gray-700',
                'inline-flex items-center border-t-2 border-transparent px-4 pt-4 text-sm font-medium',
              )}
              onClick={(event) => {
                event.preventDefault();
                refine(page);
              }}
            >
              {page + 1}
            </button>
          );
        })}
      </div>
      <div className="-mt-px flex w-0 flex-1 justify-end">
        <button
          disabled={currentRefinement === lastIndexPage}
          onClick={(event) => {
            event.preventDefault();
            refine(currentRefinement + 1);
          }}
          className="inline-flex items-center border-t-2 border-transparent pl-1 pt-4 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700"
        >
          Next
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="ml-3 h-5 w-5 text-gray-400"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
            />
          </svg>
        </button>
      </div>
    </nav>
  );
};
